package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.utils.toTextStyle
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.compose.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun ContentPlainText(
    modifier: Modifier = Modifier,
    entry: ContentEntry.PlainText,
) {
    Text(
        modifier = modifier.padding(entry.insets.toPaddingValues()),
        text = entry.text,
        style = entry.style.toTextStyle(AppTheme.textStyles.secondary_16_400),
    )
}

@Composable
@Preview(showBackground = true)
private fun ContentPlainTextPreview() {
    AppTheme {
        ContentPlainText(
            entry = ContentEntry.PlainText(
                text = "Plain Text",
                style = null,
                insets = null,
            )
        )
    }
}